import useProcess from '@hooks/useProcess';
import { useWorkflow } from '@hooks/useWorkflow';
import type { WorkflowModel } from '@models/workflow.model';
import { observer } from 'mobx-react';
import { useNavigate, useParams } from 'react-router-dom';

import { ParamsList } from '@/routes/routes.types';

import { HeaderDropdown } from './headerDropdown';

export const WorkflowSelector = observer(() => {
  const navigate = useNavigate();

  const workflowId = useParams()[ParamsList.WorkflowId] as string;
  const process = useProcess();
  const { workflow } = useWorkflow();

  const changeWorkflow = (workflowId: WorkflowModel['id']) => {
    navigate(`/${process?.id}/${workflowId}/editor`);
  };

  const dropdownItems = (process?.workflows ?? []).map(workflow => ({
    id: workflow.id,
    name: workflow.name
  }));

  if (!(workflow && process)) {
    return null;
  }
  return (
    <HeaderDropdown
      currentItemId={workflowId}
      items={dropdownItems}
      onSelect={changeWorkflow}
      type="workflow"
    />
  );
});
